module.exports = __webpack_public_path__ + "img/guarantee.ee490521.png";